import { Skeleton } from "@/components/shared/Skeleton";
import { THUMBNAIL } from "@/lib/constants/shared";
import type { ViewMode } from "@/types/viewMode";

interface ProjectCardSkeletonProps {
  viewMode?: ViewMode;
}

export function ProjectCardSkeleton({ viewMode = "grid" }: ProjectCardSkeletonProps) {
  if (viewMode === "list") {
    return (
      <div className="relative panel p-4 flex gap-5">
        {/* Thumbnail */}
        <Skeleton
          className={`w-32 ${THUMBNAIL.projectAspectRatioClass} rounded-lg flex-shrink-0 bg-gray-800`}
        />
        {/* Divider */}
        <div className="h-24 w-px bg-gradient-to-b from-transparent via-gray-800 to-transparent" />

        {/* Content */}
        <div className="flex-1 justify-center items-center">
          {/* Title */}
          <div className="space-y-3 mt-0.5">
            <Skeleton className="h-4 w-2/3 bg-gray-700" />
            <Skeleton className="h-3 w-1/3 bg-gray-700" />
          </div>

          {/* Linked Copies section */}
          <div className="py-5 px-3 space-y-1.5 border mt-4 rounded-lg">
            <Skeleton className="h-4 w-3/4 bg-gray-700" />
            <Skeleton className="h-3 w-1/2 bg-gray-700" />
          </div>
        </div>
      </div>
    );
  }

  // Grid view
  return (
    <div className="relative panel overflow-hidden">
      {/* Thumbnail */}
      <Skeleton
        className={`w-full ${THUMBNAIL.projectAspectRatioClass} rounded-2xl bg-gray-800 border-b-2 border-gray-800`}
      />

      {/* Content */}
      <div className="p-4 pt-5 space-y-2">
        <Skeleton className="h-4 w-3/4 bg-gray-700" />
        <Skeleton className="h-3 w-1/2 bg-gray-700" />
      </div>

      {/* Linked Copies section */}
      <div className="py-5 px-3 space-y-1.5 border m-4 rounded-lg">
        <Skeleton className="h-4 w-3/4 bg-gray-700" />
        <Skeleton className="h-3 w-1/2 bg-gray-700" />
      </div>
    </div>
  );
}
